export default {
    // 计算两个时间的差值
    GetTimeDiff: function (startTime, endTime) {
        var start = new Date(startTime);
        var end = new Date(endTime);
        var diffTime = (end - start)/1000; // 计算时间差，并把毫秒转换成秒

        var days = parseInt(diffTime/86400); // 天 24*60*60*1000
        var hours = parseInt(diffTime/3600) - 24 * days; // 小时 60*60 总小时数-过去的小时数=现在的小时数
        var minutes = parseInt(diffTime%3600/60); // 分钟 -（day*24）以60秒为一整份 取余 剩下的秒数/60 = 分钟数
        var seconds = parseInt(diffTime%60); // 以60秒为一整份 取余 = 剩下的秒数
        var result = ''
        if (days != null && days > 0) {
            result = result + days + '天'
        }
        if (hours != null && hours > 0) {
            result = result + hours + '小时'
        }
        if (minutes != null && minutes > 0) {
            result = result + minutes + '分钟'
        }
        if (seconds != null && seconds > 0) {
            result = result + seconds + '秒'
        }
        return result
    }
}